import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import styles from './AdminOrders.module.css';
import { apiService } from '../../services/api';
import OrderDetailsModal from '../../components/admin/OrderDetailsModal';

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = () => {
    apiService.getOrders({ limit: 100 }) // Cargar las últimas 100 órdenes
      .then(data => setOrders(data.orders || []))
      .catch(() => setOrders([]));
  };

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
     console.log('ordenes',orders)
  };

  const handleCloseModal = () => {
    setSelectedOrder(null);
  };

  const handleUpdateStatus = async (orderId, newStatus) => {
    await apiService.updateOrderStatus(orderId, newStatus);
    // Recargar órdenes para reflejar el cambio
    loadOrders();
  };

  return (
    <AdminLayout>
      <div className={styles.ordersManagement}>
        <div className={styles.header}>
          <h1>Órdenes</h1>
        </div>
        <div className={styles.ordersTable}>
          <div className={styles.tableHeader}>
            <div>Cliente</div>
            <div>Correo</div>
            <div>Teléfono</div>
            <div>Dirección</div>
            <div>Total</div>
            <div>Estado</div>
            <div>Fecha</div>
          </div>
          {orders.map(order => (
            <div 
              key={order.id} 
              className={styles.tableRow}
              onClick={() => handleOrderClick(order)}
            >
              <div>{order.user_name}</div>
              <div>{order.user_email}</div>
              <div>{order.user_phone}</div>
              <div>{order.user_address}</div>
              <div>${order.total?.toFixed(2)}</div>
              <div>
                <span className={styles[order.status]}>
                  {order.status.charAt(0).toUpperCase() + order.status.slice(1).replace('_', ' ')}
                </span>
              </div>
              <div>{new Date(order.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      </div>

      {selectedOrder && (
        <OrderDetailsModal
          order={selectedOrder}
          onClose={handleCloseModal}
          onUpdateStatus={handleUpdateStatus}
        />
      )}
    </AdminLayout>
  );
};

export default AdminOrders;